// ── AN ONGOING'S CONVERSATIONS (busy-my-web#654) ────────────────────────────────────────────────
//
//   💬  3 Conversations              ← the Briefing row, a count like "2 Research packs"
//       Flights to Lisbon   Oct 21 · View ↗
//       Hotel shortlist     Oct 19 · View ↗
//
// An Ongoing's chat used to be ONE conversation — the live session of `ongoing:<id>`, which
// research.js's `loadSession` restores — and everything archived before it, plus every conversation
// saved here from Home ("Save conversation", lib/saveConversation.js), had nowhere to be seen. The
// Briefing is where a story says what it is made of, so that is where they are counted and listed.
//
// The COUNT is the server's (`GET v1/chat/sessions?scope=ongoing:<id>` → `count`, busy-timeline-
// srv#654: archived sessions plus a live one with a message), because `recent[]` is a page and a
// page is not a total. A BFF that predates the field is answered from what came back instead.
//
// Pure: the fetch is store/modules/ongoingChats.js's, the list is SmartBox/ConversationsPanel.vue's.

import { railStamp } from '@/lib/chatRail'

/** The Briefing row's filter name — what the strip and `briefing/toggleFilter` agree to call it. */
export const CONVERSATIONS_FILTER = 'conversations'

/** The row's glyph: the app's own chat bubble (icon-packs/…/chat.svg), the rail discs' shape. */
export const CONVERSATIONS_ICON = 'chat'

/** How many of an Ongoing's conversations one read lists. */
export const CONVERSATIONS_TAKE = 50

export const CONVERSATIONS_TEXT = {
  heading: 'Conversations',
  view: 'View',
  live: 'Current',
  untitled: 'Conversation',
}

const clean = (v) => String(v ?? '').replace(/\s+/g, ' ').trim()
const list = (v) => (Array.isArray(v) ? v.filter((s) => s && s.id) : [])

/**
 * A live session counts once something was said in it. Read off its NAME: the store titles a
 * session from its first question (`Title ??= first user message`), so a live box that has only
 * been opened has none — exactly the "opened-but-empty" case the server's count leaves out.
 */
const liveCounts = (live) => !!(live && live.id && (clean(live.title) || Number(live.questionCount) > 0))

/** The sessions answer's conversations, newest first: the live one (when it counts) and the rest. */
export function conversationSessions(data) {
  const live = data?.live && data.live.id ? data.live : null
  const past = list(data?.recent).filter((s) => !live || String(s.id) !== String(live.id))
  const all = [...(liveCounts(live) ? [live] : []), ...past.filter((s) => s.isArchived || liveCounts(s))]
  const at = (s) => Date.parse(s.updatedUtc || s.lastMessageUtc || s.createdUtc || '') || 0
  return all.sort((a, b) => at(b) - at(a))
}

/** How many conversations the Ongoing holds — the server's `count`, else what came back. */
export function conversationCount(data) {
  if (!data) return 0
  const served = Number(data.count)
  if (Number.isFinite(served) && served >= 0 && data.count !== null && data.count !== undefined) return served
  return conversationSessions(data).length
}

/** The rows the Briefing lists under "N Conversations". */
export function conversationRows(data) {
  const liveId = data?.live?.id ? String(data.live.id) : null
  return conversationSessions(data).map((s) => {
    const stamp = railStamp(s.updatedUtc || s.lastMessageUtc || s.createdUtc)
    return {
      id: String(s.id),
      title: clean(s.title) || CONVERSATIONS_TEXT.untitled,
      stamp: stamp.date,
      live: !!liveId && String(s.id) === liveId,
    }
  })
}
